import { useCallback, useState } from "react";

import {
	persistUsersRefreshMs,
	readUsersRefreshMs,
	type UsersRefreshMs,
} from "@/features/users/lib/users-refresh";

export function useUsersRefresh() {
	const [refreshMs, setRefreshMsState] = useState(readUsersRefreshMs);

	const setRefreshMs = useCallback((next: UsersRefreshMs) => {
		setRefreshMsState(next);
		persistUsersRefreshMs(next);
	}, []);

	return { refreshMs, setRefreshMs };
}
